import { Component, Input } from '@angular/core';

/**
 * Wraps a button the user may lack the permission for, such as the End
 * Customer widget's Add End Customer (end-customers:create, issue #533) and
 * Save (end-customers:edit, issue #620). The button disables itself; a
 * disabled button takes no focus and shows no tooltip, so while the
 * permission is missing the wrapper names it in a tooltip and takes the
 * focus instead. Until the current user loads, the permission is unknown and
 * the wrapper says nothing.
 */
@Component({
  selector: 'app-permission-gate',
  template: `
    <span
      class="permission-gate"
      [matTooltip]="allowed === false ? tooltip : ''"
      [matTooltipDisabled]="allowed !== false"
      [attr.tabindex]="allowed === false ? 0 : null">
      <ng-content></ng-content>
    </span>
  `,
})
export class PermissionGateComponent {
  /** Whether the user holds the permission: null until the current user loads. */
  @Input() public allowed: boolean | null = null;

  /** The permission the wrapped button needs, such as `end-customers:edit`. */
  @Input() public permission = '';

  public get tooltip(): string {
    return `Requires the ${this.permission} permission`;
  }
}
